"use client"
import React, { useRef, useEffect, useState } from 'react';
import styled from "styled-components";
import { useLanguage } from '@/app/utils/LanguageContext';
import { useMyContext } from '@/app/utils/MyContext';
import { textSize, text_size } from "@/app/utils/MixinSize";
import { getArticle } from "@/app/utils/request/requestList"; 

const Container = styled.div<{ $twoASwitch: boolean }>` 
    height: 100%;
    overflow: auto;
    >div {
        width: ${({ $twoASwitch }) => ($twoASwitch ? "100%" : "calc(100% - 200px)")}; 
        padding: ${({ $twoASwitch }) => ($twoASwitch ? "16px" : "")}; 
        margin:  ${({ $twoASwitch }) => ($twoASwitch ? "" : "24px auto")};
        >div {
            margin-top: ${({ $twoASwitch }) => ($twoASwitch ? "" : "24px")};
        }
         
    }    
    &::-webkit-scrollbar-thumb {
        background-color: #B9B9B9;
        -webkit-border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: #B9B9B9;
        -webkit-border-radius: 4px;
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-track-piece {
        -webkit-border-radius: 0;
      }
      &::-webkit-scrollbar-thumb:active{
        background-color:#cccccc;
        -webkit-border-radius:4px;
      } 
      @media only screen and (max-width: 1439px) {
        .leftContent{
            width: ${({ $twoASwitch }) => ($twoASwitch ? "60% !important" : "")}; 
        }
        .rightContent{
            width: ${({ $twoASwitch }) => ($twoASwitch ? "40% !important" : "")}; 
        }
    }   
`;

const ArticleTit = styled.div`
    ${text_size(18)}  
    font-weight: 700;
    line-height: 17px;   
    color: rgba(0, 0, 0, 1); 
`;
const ArticleContent = styled.div<{ $isMobile: boolean }>`
    ${text_size(13)}  
    font-weight: 500; 
    line-height: 17px;   
    color: #333333;
    max-width: 656px;
    img { 
        max-width:${({ $isMobile }) => ($isMobile ? "100%" : "656px")};        
    }
`;

const ArticleContentUp = styled.div<{ $isMobile: boolean }>`
    ${text_size(13)}  
    font-weight: 400; 
    line-height: 18px;   
    color: #000000; 
    img { 
        width: 100%;        
    }
`;
const ArticleImg = styled.div<{ $isMobile: boolean }>`
    padding: ${({ $isMobile }) => ($isMobile ? "16px 0" : "20px 0")};        
    img {
        width: 100%;
    }
`;

const MContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 999; 
    > div:last-child {
        height: calc(100% - 48px);
        padding: 20px 16px;
        overflow: auto; 
        >div {
            padding-top: 20px;
        }
        >div:first-child {
            padding-top: 0;
        } 
    }
`;

const DivMobileHeader = styled.div`
  display: flex;
  width: 100%;
  height: 48px;
  line-height: 48px;
  background: linear-gradient(180deg, #012c60 0%, #01336f 100%);
`;
const DivMobileHeaderBack = styled.div`
  width: 84px;
  div {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  padding: 0 0 0 8px;
  display: flex;
  align-items: center;
`;
const DivMobileHeaderTitle = styled.div`
  display: flex;
  width: 100%;
  color: #ffffff;
  ${text_size(18)}
  font-weight: 700;
  text-align: center;
  justify-content: center;
`;


const ArticleViewer: React.FC<any> = (props: any) => {
    //const { type, isOpen, onRequestClose } = props;
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [isDisplay, setIsDisplay] = useState(props?.isOpen);
    const [articleData, setArticleData] = useState<any>([]);

    const isMobile = props?.type == "mobile";
    const selectRace = myContextState.selectedRace?.displayName;
    const TwoASwitch = window.globalConfig?.TwoASwitch as boolean;

    useEffect(() => {  
        getArticle(
            lang.langCode,
            myContextState.season,
            myContextState.selectedMeeting?.displayName,
            props?.name
        )
            .then((res: any) => {
                const articleList = [] as any[] ; 
                res?.item?.Article?.forEach((item: any) => {
                    const curRace = item?.race?.targetItems.filter((r: any) => r.displayName == selectRace)
                    if(curRace && curRace.length > 0){
                        articleList.push(item);
                    }
                });
                setArticleData(articleList); 
            })
            .catch((e: any) => {
                console.log(e);
            });
    }, [myContextState.selectedMeeting?.displayName, myContextState.selectedRace?.displayName, props?.name]);
    
    const handleClose = () => {
        setIsDisplay(false);
        props.onRequestClose();
 
    } 

    return (
        <>
            {
                props?.type === "pc" ? (
                    <Container $twoASwitch={TwoASwitch}>
                        <div>
                            {
                                articleData?.map((item: any, index: number) => (
                                    TwoASwitch ? 
                                    <div key={`Article_${index}`} style={{display: "flex", marginBottom: "20px"}}> 
                                        <div className='leftContent' style={{width: '50%', paddingRight: '12px'}}> 
                                        <ArticleTit style={{paddingBottom: "12px",...textSize(17)}} >{item?.title?.value}</ArticleTit>
                                            <ArticleContentUp $isMobile={isMobile} dangerouslySetInnerHTML={{ __html: item?.description?.rendered ?? '' }}> 
                                            </ArticleContentUp>
                                        </div>  
                                        <ArticleImg className='rightContent' $isMobile={isMobile} style={{width: '50%', padding: '0 0 0 12px'}}>
                                            <img src={item?.imageUrl?.src}></img>
                                        </ArticleImg>  
                                    </div>
                                    :
                                    <div key={`Article_${index}`}>
                                        <ArticleTit>{item?.title?.value}</ArticleTit>
                                        <ArticleImg $isMobile={isMobile}>
                                            <img src={item?.imageUrl?.src}></img>
                                        </ArticleImg>
                                        <ArticleContent $isMobile={isMobile} dangerouslySetInnerHTML={{ __html: item?.description?.rendered ?? '' }}> 
                                            </ArticleContent>
                                    </div>
                                ))
                            } 
                        </div>
                    </Container>
                ) : (
                    <MContainer style={{display: isDisplay ? "block" : "none"}}>
                        <DivMobileHeader>
                            <DivMobileHeaderBack onClick={handleClose}>
                                <div>
                                    <img src={`${myContextState.assetPrefix}/navigate_before.svg`} />
                                </div>
                            </DivMobileHeaderBack>
                            <DivMobileHeaderTitle>{t("article_header_title")}</DivMobileHeaderTitle>
                            <DivMobileHeaderBack></DivMobileHeaderBack>
                        </DivMobileHeader>
                        <div className='articleBody'>
                            {
                                articleData?.map((item: any, index: number) => (
                                    <div key={`Article_${index}`}>
                                        <ArticleTit >{item?.title?.value}</ArticleTit>
                                        <ArticleImg $isMobile={isMobile}>
                                            <img src={item?.imageUrl?.src}></img>
                                        </ArticleImg>
                                        <ArticleContent $isMobile={isMobile} dangerouslySetInnerHTML={{ __html: item?.description?.rendered ?? '' }}> 
                                        </ArticleContent>
                                    </div>
                                ))
                            } 
                        </div>
                    </MContainer>
                )
            }
        </>
    );
};

export default ArticleViewer